import { Component, OnInit } from '@angular/core';
import { PlusdCommonService } from '../../services/plusd-common.service';
import { XsAppConfigService } from 'src/app/common/services/xs-app-config.service';
import * as moment from "moment";
import { SolicitudService } from '../../services/solicitud.service';
import { MatDialog } from '@angular/material';
import { ContactoDetalleComponent } from '../contacto-detalle/contacto-detalle.component';
import { ArchivoService } from "../../services/archivo.service";

@Component({
  selector: 'app-contacto-listado',
  templateUrl: './contacto-listado.component.html',
  styleUrls: ['./contacto-listado.component.css']
})
export class ContactoListadoComponent implements OnInit {
  columnsToDisplay = [];
  dataSource = [];
  columnasVisibles = [];
  filtro: any = {};
  loading: boolean = false;
  urlBase: string;
  subsector: string;
  permiso: string;
  pagina: number = 1;

  constructor(
    public plusdCommonService: PlusdCommonService,
    public xsAppConfigService: XsAppConfigService,
    public solicitudService: SolicitudService,
    public dialog: MatDialog,
    public archivoService: ArchivoService,
  ) { }

  inicializaGrilla() {
    this.columnsToDisplay = [
      { nombre: "opciones", titulo: "Opción", visible: true, tipo: "" },
      { nombre: "nombreContacto", titulo: "Contacto", visible: true, tipo: "string" },
      { nombre: "cargoContacto", titulo: "Cargo", visible: true, tipo: "string" },
      { nombre: "correo", titulo: "Correo", visible: true, tipo: "string" },
      { nombre: "telefono", titulo: "Teléfono", visible: true, tipo: "string" },
      { nombre: "estadoContacto", titulo: "Estado", visible: true, tipo: "string" },
      { nombre: "nombreArchivo", titulo: "Carta Poder", visible: true, tipo: "string" }
    ];
    this.columnasVisibles = this.seleccionarColumnasVisibles(this.columnsToDisplay);
  }

  ngOnInit() {
    this.urlBase = this.plusdCommonService.APPLICATION_API_HOST;
    this.subsector = this.xsAppConfigService.ID_SUBSECTOR;
    this.permiso = this.xsAppConfigService.APLICACION_PERFIL;
    this.inicializaGrilla();
    this.inicializar();
  }

  inicializar() {
    if (this.permiso == "ADMINISTRADO") {
      this.filtro.ruc = this.xsAppConfigService.APLICACION_USUARIO_WINDOWS;
    }
    this.filtro.idSubsector = this.subsector;
   /* this.solicitudService.inicializarContacto(this.filtro).then(res => {
      this.dataSource = res.data.listaSolicitudDetalle;
      console.log("El datasource", this.dataSource);
    });*/
  }

  seleccionarColumnasVisibles(columnas) {
    var columnasVisibles = columnas.filter(c => {
      return c.visible;
    });
    var nombreColsVisibles = columnasVisibles.map(c => {
      return c.nombre;
    });
    return nombreColsVisibles;
  }

  formatearColumna(element, column) {
    switch (column.tipo) {
      case "date":
        return element[column.nombre] ? moment(element[column.nombre]).format("DD/MM/YYYY") : "";
      case "decimal":
        return parseFloat(element[column.nombre]).toFixed(column.fixed);
      default:
        return element[column.nombre];
    }
  }

  classHeaderColumna(columna) {
    return "xs-header-cell";
  }

  onClickBuscar() {
    this.inicializar();
  }

  onKey() {
    this.inicializar();
  }

  openTab(element) {
    let url;
    let params = {
      uiid: element.uiid,
    }
    /*this.archivoService.consultarArchivo(params).then(res => {
      if (res.data.estado) {
        url = res.data.fullUrlDownload
        window.open(url, "_blank");
      }
    });*/
  }

  onClickAgregar() {
    const params = {
      opcion: "AGREGAR",
    }
    this.mostrarDlgContacto(params);
  }

  onClickModificar(element) {
    const params = {
      opcion: "MODIFICAR",
      idSolicitud: element.idSolicitud,
      idSolicitudDetalle: element.idSolicitudDetalle
    }
    this.mostrarDlgContacto(params);
  }

  /*---------------------------------------------------*/
  /*-----------------------DIALOGO---------------------*/
  /*---------------------------------------------------*/

  mostrarDlgContacto(params) {
    const dialogRef = this.dialog.open(ContactoDetalleComponent, {
      width: "700px",
      height: "200px",
      panelClass: "xs-dlg-base",
      disableClose: true,
      data: params
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.estado == 'ACEPTAR') {
        this.inicializar();
      }
    });
  }

}
